import { render, staticRenderFns } from "./singleFlow.vue?vue&type=template&id=0c4772ea&scoped=true&lang=pug&"
import script from "./singleFlow.vue?vue&type=script&lang=js&"
export * from "./singleFlow.vue?vue&type=script&lang=js&"
import style0 from "./singleFlow.vue?vue&type=style&index=0&id=0c4772ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4772ea",
  null
  
)

export default component.exports